import { Button } from "@/components/ui/button";
import { ShieldAlert, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function AccessDenied({ module }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-sm border border-slate-200 p-8 text-center" data-testid="access-denied-screen">
        <div className="mx-auto h-14 w-14 rounded-full bg-red-50 border border-red-200 flex items-center justify-center mb-5">
          <ShieldAlert className="h-6 w-6 text-red-600" />
        </div>
        <h1 className="text-xl font-semibold text-slate-900 mb-2" data-testid="access-denied-title">
          Access Denied
        </h1>
        <p className="text-sm text-slate-600 leading-relaxed mb-2">
          You don&apos;t have permission to view this page.
        </p>
        {module && (
          <p className="text-xs text-slate-400 mb-6 font-mono">Required module: {module}</p>
        )}
        <Button variant="outline" onClick={() => navigate("/")} data-testid="access-denied-home">
          <ArrowLeft className="h-4 w-4 mr-1.5" />
          Back to home
        </Button>
      </div>
    </div>
  );
}
